import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import ViewDashboardOperacionalVendaSemAssinatura from "../views/ViewDashboardOperacionalVendaSemAssinatura";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const DashboardOperacionalVendaSemAssinatura: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");

  if (isLoading) {
    return <p>Verificando permissao...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/dashboardOperacional">
      <ViewDashboardOperacionalVendaSemAssinatura />
    </AdminSectionShell>
  );
};

export default DashboardOperacionalVendaSemAssinatura;
